import { useEffect, useState } from 'react';

const defaultLoadingRanges = [
    {
        range: [0, 20],
        time: 500
    },
    {
        range: [21, 50],
        time: 5000
    },
    {
        range: [51, 85],
        time: 2000
    },
    {
        range: [86, 100],
        time: 100
    }
];

export const useLoadingProgress = ({ onDone, loadingRanges }: { onDone: () => void, loadingRanges?: Array<{ range: Array<number>, time: number }> }) => {
    const lRange = loadingRanges || defaultLoadingRanges;

    const [progress, setProgress] = useState({ percents: 0, label: '' });
    const [step, setStep] = useState(0);

    useEffect(() => {
        const stepInterval = lRange[step].time;
        let percents = progress.percents;
        let timeoutId: any;

        let intervalId = setInterval(() => {
            percents = Math.floor(Math.min(percents + 1, 100));

            if (percents === 100) {
                if (onDone) {
                    timeoutId = setTimeout(onDone, 200);
                }
                clearInterval(intervalId);
            }

            if (percents === lRange[step].range[1]) {
                setStep((step + 1) % 4)
            }

            setProgress({
                percents,
                label: `${percents}%`,
            });
        }, stepInterval / (lRange[step].range[1] - lRange[step].range[0]));

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
        };
    }, [onDone, progress.percents]);

    return { progress };
};
